var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImgCell',{attrs:{"image":_vm.image || (_vm.team && _vm.team.image),"label":_vm.name,"variant":_vm.variant}})}
var staticRenderFns = []

export { render, staticRenderFns }